const routes = [
  {
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    component: () => import("~/pages/NotFound.vue"),
    meta: {
      module: "NOTFOUND",
    },
  },
  {
    path: "/:lang(en)",
    alias: "/:lang(id)",
    name: "home",
    component: () => import("~/pages/HomePage.vue"),
    meta: {
      module: "HOME",
    },
  },
  // {
  //   path: "/:lang(en)/sustainability",
  //   alias: "/:lang(id)/keberlanjutan",
  //   name: "commitment",
  //   component: () => import("~/pages/CommitmentPage.vue"),
  //   meta: {
  //     module: "COMMITMENT",
  //   },
  // },
  {
    path: "/:lang(en)/about-spil",
    alias: "/:lang(id)/tentang-spil",
    name: "about-company",
    component: () => import("~/pages/company/AboutCompanyPage.vue"),
    meta: {
      module: "COMPANY",
    },
  },
  {
    path: "/:lang(en)/company/history",
    alias: "/:lang(id)/perusahaan/sejarah",
    name: "history-company",
    component: () => import("~/pages/company/HistoryCompanyPage.vue"),
    meta: {
      module: "COMPANY",
    },
  },
  {
    path: "/:lang(en)/company/group",
    alias: "/:lang(id)/perusahaan/grup",
    name: "group-company",
    component: () => import("~/pages/company/GroupCompanyPage.vue"),
    meta: {
      module: "COMPANY",
    },
  },
  {
    path: "/:lang(en)/careers",
    alias: "/:lang(id)/karir",
    name: "career-company",
    component: () => import("~/pages/company/CareerCompanyPage.vue"),
    meta: {
      module: "COMPANY",
    },
  },
  {
    path: "/:lang(en)/company/career/:slug",
    alias: "/:lang(id)/perusahaan/karir/:slug",
    name: "career-detail-company",
    component: () => import("~/pages/company/CareerDetailCompanyPage.vue"),
    meta: {
      module: "COMPANY",
    },
  },
  {
    path: "/:lang(en)/services",
    alias: "/:lang(id)/layanan",
    name: "type-service",
    component: () => import("~/pages/service/TypeServicePage.vue"),
    meta: {
      module: "SERVICE",
    },
  },
  {
    path: "/:lang(en)/service/guide",
    alias: "/:lang(id)/layanan/panduan",
    name: "guide-service",
    component: () => import("~/pages/service/GuideServicePage.vue"),
    meta: {
      module: "SERVICE",
    },
  },
  {
    path: "/:lang(en)/service/guide/:slug",
    alias: "/:lang(id)/layanan/panduan/:slug",
    name: "guide-detail-service",
    component: () => import("~/pages/service/GuideDetailServicePage.vue"),
    meta: {
      module: "SERVICE",
    },
  },
  {
    path: "/:lang(en)/service/guide/:topicid/:subtopicid",
    alias: "/:lang(id)/layanan/panduan/:topicid/:subtopicid",
    name: "guide-detail-service-new",
    component: () => import("~/pages/service/GuideDetailServicePage.vue"),
    meta: {
      module: "SERVICE",
    },
  },
  {
    path: "/:lang(en)/service/route/:slug",
    alias: "/:lang(id)/layanan/rute/:slug",
    name: "route-service",
    component: () => import("~/pages/service/RouteServicePage.vue"),
    meta: {
      module: "SERVICE",
      key: "route-service",
    },
  },
  {
    path: "/:lang(en)/contact",
    alias: "/:lang(id)/kontak",
    name: "contact-us",
    component: () => import("~/pages/ContactUsPage.vue"),
    meta: {
      module: "CONTACT",
    },
  },
  {
    path: "/:lang(en)/myspil",
    alias: "/:lang(id)/myspil",
    name: "myspilcom",
    component: () => import("~/pages/mySPILcomPage.vue"),
    meta: {
      module: "MYSPILCOM",
    },
  },
  {
    path: "/:lang(en)/green-earth",
    alias: "/:lang(id)/dampak-hijau",
    name: "green-earth",
    component: () => import("~/pages/green-earth/GreenImpactPage.vue"),
    meta: {
      module: "GREENEARTH",
    },
  },
  {
    path: "/:lang(en)/green-earth/:section",
    alias: "/:lang(id)/dampak-hijau/:section",
    name: "green-earth-category",
    component: () => import("~/pages/green-earth/[section].vue"),
    meta: {
      module: "GREENEARTH",
    },
  },
  {
    path: "/:lang(en)/green-earth/:section/detail/:slug",
    alias: "/:lang(id)/dampak-hijau/:section/detail/:slug",
    name: "green-earth-detail",
    component: () => import("~/pages/green-earth/[section]/[slug].vue"),
    meta: {
      module: "GREENEARTH",
    },
  },
  {
    path: "/:lang(en)/news",
    alias: "/:lang(id)/berita",
    name: "news",
    component: () => import("~/pages/news/NewsPage.vue"),
    meta: {
      module: "NEWS",
    },
  },
  {
    path: "/:lang(en)/news/:slug",
    alias: "/:lang(id)/berita/:slug",
    name: "news-detail",
    component: () => import("~/pages/news/NewsDetailPage.vue"),
    meta: {
      module: "NEWS",
    },
  },
  {
    path: "/:lang(en)/insight",
    alias: "/:lang(id)/wawasan",
    name: "outlook",
    component: () => import("~/pages/outlook/OutlookPage.vue"),
    meta: {
      module: "OUTLOOK",
    },
  },
  {
    path: "/:lang(en)/insight/:slug",
    alias: "/:lang(id)/wawasan/:slug",
    name: "outlook-detail",
    component: () => import("~/pages/outlook/OutlookDetailPage.vue"),
    meta: {
      module: "OUTLOOK",
    },
  },
  {
    path: "/:lang(en)/spildex",
    alias: "/:lang(id)/spildex",
    name: "spildex",
    component: () => import("~/pages/SPILDexPage.vue"),
    meta: {
      module: "SPILDEX",
    },
  },
  {
    path: "/instantquotes",
    name: "instantquotes",
    component: () => import("~/pages/SPILPrimePage.vue"),
    meta: {
      layout: "spil-prime",
      module: "INSTANTQUOTES",
    },
  },
  {
    path: "/:lang(en)/tpil",
    alias: "/:lang(id)/tpil",
    name: "tpil",
    component: () => import("~/pages/TPILPage.vue"),
    meta: {
      module: "TPIL",
    },
  },
  {
    path: "/:lang(en)/verify/:code",
    alias: "/:lang(id)/verifikasi/:code",
    name: "verifyemail",
    component: () => import("~/pages/VerifyEmailPage.vue"),
    meta: {
      module: "VERIFY",
    },
  },
  {
    path: "/spilprime",
    name: "spilprime",
    component: () => import("~/pages/SPILPrimePage.vue"),
    meta: {
      layout: "spil-prime",
      module: "SPILPRIME",
    },
  },
  {
    path: "/sitemap",
    name: "sitemap",
    component: () => import("~/pages/SitemapPage.vue"),
    meta: {
      module: "SITEMAP",
    },
  },
];

export default {
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }

    if (to.hash) {
      return { el: to.hash, behavior: "smooth" };
    }

    const isGreenEarthLanguageSwitch =
      to.meta?.module === "GREENEARTH" &&
      from.meta?.module === "GREENEARTH" &&
      to.name === from.name &&
      to.params?.lang !== from.params?.lang;

    if (isGreenEarthLanguageSwitch) {
      return false;
    }

    const isRouteServiceTabSwitch =
      to.name === "route-service" &&
      from.name === "route-service";

    if (isRouteServiceTabSwitch) {
      return false;
    }

    return { top: 0 };
  },

  routes: (_routes) => routes,
};

export { routes };
